// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3ClMS","question":"Question_question__mH-yS","description":"Question_description__kv_zJ"};